<template>
    <div class="reason-main">
        <div class="reason-title">
            {{userInfo.screen_name}}さん、こんにちは！ <br>
            {{lang.delete_default}}
        </div>
        <div class="list">
            <template v-for="(item, index) in reasonList">
                <div :key="index" class="item">
                    <div @click="toggleCheck(index)" class="main-section">
                        <div
                            :class="['check-box', item.checked && 'checked-box']"
                        ></div>
                        <div class="label">
                            {{ item.des }}
                        </div>
                    </div>
                    <div v-if="typeof(item.customReason) === 'string'" class="custom">
                        <Input
                            :disabled="!item.checked"
                            resize="none"
                            type="textarea"
                            :rows="2"
                            placeholder="入力してください"
                            v-model="item.customReason"
                        />
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { Input } from '../ElComponents';

export default {
    name: 'ReasonList',
    data() {
        return {
            reasonList: [
                {
                    des: '他のPokekaraアカウントを利用している',
                    checked: false
                },
                {
                    des: '今後Pokekaraを利用したくないから',
                    checked: false
                },
                {
                    des: 'アカウントの連携を解除できないから',
                    checked: false
                },
                {
                    des: 'プライバシーを守るため',
                    checked: false,
                },
                {
                    des: 'その他',
                    checked: false,
                    customReason: ''
                }
            ]
        };
    },
    props: ['userInfo'],
    computed: {
        canSubmit() {
            let can = false;
            const reasonList = this.reasonList;
            reasonList.forEach(item => {
                if (item.checked) {
                    if (typeof(item.customReason) !== 'string') {
                        can = true;
                    } else if (item.customReason.trim().length) {
                        can = true;
                    }
                }
            });
            return can;
        },
    },
    watch: {
        canSubmit(isCan) {
            this.$emit('toggle-can-submit', isCan);
        }
    },
    components: {
        Input
    },
    methods: {
        toggleCheck(index) {
            const self = this;
            self.reasonList[index].checked = !self.reasonList[index].checked;
        }
    }
};
</script>

<style lang="scss" scoped rel="stylesheet/scss">
@import '../../../common/sass/basic/mixin';

.reason-main {
    margin-top: 40px;
    .reason-title {
        padding-bottom: 7px;
        border-bottom: 1px solid rgb(20, 20, 20);
        font-size: 24px;
        font-family: 'Hiragino Sans GB';
        color: rgb(20, 20, 20);
        line-height: 38px;
        font-weight: bold;
    }

    .list {
        .item {
            font-size: 18px;
            font-family: 'Hiragino Sans';
            color: rgb(20, 20, 20);
            margin-top: 27px;

            .main-section {
                @include flexpipe();
                @include alignitem(center);
                cursor: pointer;

                .check-box {
                    width: 22px;
                    height: 22px;
                    box-sizing: border-box;
                    border: 2px solid rgb(20, 20, 20);
                    border-radius: 50%;
                    margin-right: 18px;
                }

                .checked-box {
                    border: none;
                    background: center/100% 100% no-repeat
                        url('../../assets/cancellation/icon-checked-reason.png');
                }

                .label {
                    line-height: 18px;
                }
            }

            .custom {
                margin: 22px auto 0 40px;

                .el-textarea__inner {
                    height: 66px;
                }
            }
        }
    }
}
</style>
